import { render, staticRenderFns } from "./ProjectManagerTile.vue?vue&type=template&id=0ec0b537"
import script from "./ProjectManagerTile.vue?vue&type=script&lang=js"
export * from "./ProjectManagerTile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports